import request from '@/utils/request'

export function listMenus (data) {
  return request({
    url: '/osp/resource/listMenus',
    method: 'post',
    data: data
  })
}

// export function listTree (data) {
//   return request({
//     url: '/ids/resource/listTree',
//     method: 'post',
//     data: data
//   })
// }
//
// export function saveBo (data) {
//   return request({
//     url: '/ids/resource/saveBo',
//     method: 'post',
//     data: data
//   })
// }
//
// export function updateByBo (data) {
//   return request({
//     url: '/ids/resource/updateByBo',
//     method: 'post',
//     data: data
//   })
// }
//
// export function deleteByIds (data) {
//   return request({
//     url: '/ids/resource/deleteByIds',
//     method: 'post',
//     data: data
//   })
// }
